import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import { isAmloBlocked } from 'identity/selectors'
import { PATH, ROUTE_PATH } from 'quick-quote/constants/path'

export const AMLO_WHITELIST_PATHS = [ROUTE_PATH.PORTAL, '/e-kyc', '/authorize', PATH.QUICK_QUOTE, PATH.BROCHURE]

const isWhitelisted = (pathname) => {
  if (!pathname) return false
  return AMLO_WHITELIST_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`))
}

export const _RequireAmlo = ({ amloBlocked, location, children }) => {
  if (amloBlocked && !isWhitelisted(location && location.pathname)) {
    return <Redirect to={ROUTE_PATH.PORTAL} />
  }
  return children
}

const mapStateToProps = (state) => ({
  amloBlocked: isAmloBlocked(state),
})

export default connect(mapStateToProps)(_RequireAmlo)

export const withRequireAmlo = (Component) => (props) => {
  const RequireAmlo = connect(mapStateToProps)(_RequireAmlo)
  return (
    <RequireAmlo location={props.location}>
      <Component {...props} />
    </RequireAmlo>
  )
}
